// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.molecule-editor {
  padding: 16px 20px;
  min-height: calc(100vh - 68px);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 顶部标题 */
.editor-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e2e8f0;
}

.editor-header-icon {
  font-size: 20px;
  color: #6366f1;
}

.editor-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #334155;
}

/* 主区域：Ketcher + 操作按钮，居中 */
.editor-main {
  display: flex;
  flex: 1 1;
  gap: 16px;
  min-height: 0;
  justify-content: center;
}

/* 左侧列（SMILES 输入行 + Ketcher 面板），占 70% */
.editor-left-column {
  flex: 0 0 70%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

/* SMILES 标签 */
.editor-smiles-label {
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  color: #475569;
  flex-shrink: 0;
}

/* SMILES 输入行 */
.editor-input-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.editor-input-wrapper {
  flex: 1 1;
}

.editor-smiles-input {
  width: 100%;
  font-family: "Courier New", Consolas, monospace;
  font-size: 14px;
  padding: 8px 12px;
}

.editor-btn {
  white-space: nowrap;
  flex-shrink: 0;
}

/* Ketcher 面板 — 填满左侧列剩余空间 */
.editor-ketcher-panel {
  flex: 1 1;
  min-height: 400px;
  position: relative;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  overflow: hidden;
  background: #fafbfc;
}

.ketcher-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.ketcher-loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.85);
}

.ketcher-loading-text {
  color: #64748b;
  font-size: 14px;
  margin: 0;
}

/* 右侧操作按钮面板 */
.editor-actions-panel {
  width: 180px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}

.actions-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #475569;
  text-align: center;
}

.actions-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.action-btn {
  width: 100%;
  justify-content: flex-start;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/screen-tools/MoleculeEditor/MoleculeEditor.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAO;EACP,SAAS;EACT,aAAa;EACb,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,+CAA+C;EAC/C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA,aAAa;AACb;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB","sourcesContent":[".molecule-editor {\n  padding: 16px 20px;\n  min-height: calc(100vh - 68px);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* 顶部标题 */\n.editor-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.editor-header-icon {\n  font-size: 20px;\n  color: #6366f1;\n}\n\n.editor-title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #334155;\n}\n\n/* 主区域：Ketcher + 操作按钮，居中 */\n.editor-main {\n  display: flex;\n  flex: 1;\n  gap: 16px;\n  min-height: 0;\n  justify-content: center;\n}\n\n/* 左侧列（SMILES 输入行 + Ketcher 面板），占 70% */\n.editor-left-column {\n  flex: 0 0 70%;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-width: 0;\n}\n\n/* SMILES 标签 */\n.editor-smiles-label {\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 500;\n  color: #475569;\n  flex-shrink: 0;\n}\n\n/* SMILES 输入行 */\n.editor-input-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.editor-input-wrapper {\n  flex: 1;\n}\n\n.editor-smiles-input {\n  width: 100%;\n  font-family: \"Courier New\", Consolas, monospace;\n  font-size: 14px;\n  padding: 8px 12px;\n}\n\n.editor-btn {\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n/* Ketcher 面板 — 填满左侧列剩余空间 */\n.editor-ketcher-panel {\n  flex: 1;\n  min-height: 400px;\n  position: relative;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #fafbfc;\n}\n\n.ketcher-iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n\n.ketcher-loading-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  background: rgba(255, 255, 255, 0.85);\n}\n\n.ketcher-loading-text {\n  color: #64748b;\n  font-size: 14px;\n  margin: 0;\n}\n\n/* 右侧操作按钮面板 */\n.editor-actions-panel {\n  width: 180px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n\n.actions-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #475569;\n  text-align: center;\n}\n\n.actions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.action-btn {\n  width: 100%;\n  justify-content: flex-start;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
